<aside>
	<fn-scrollbar
		[options]="{ scrollbarMinSize: 20, autoHide: false }"
		[position]="'left'"
		class="sidebarScroll"
	>
		<ul
			class="navbar-nav mr-auto sidenav side-bar-menu"
			id="navAccordion"
			[style.height]="sidebarHeight"
			fn-menu-item
			[fnMenuItem]="menuData"
		></ul>
	</fn-scrollbar>
</aside>
